<script setup lang="ts">
import { viteConfig } from '@/services/utils';
import { RouterLink } from 'vue-router';

</script>

<template>
  <v-footer class="app-footer mt-8">
    <div class="d-flex flex-column flex-md-row justify-space-between align-center w-100 pa-4">
      <!-- Brand/Logo section -->
      <div class="text-medium-emphasis text-center text-md-left mb-2 mb-md-0">
        <!-- <small>⚜ Azzibbo games</small> -->
        <!-- <small class="mx-2">|</small>
        <a href="/en/" class="text-medium-emphasis text-decoration-none footer-link"><small>{{ viteConfig('APP_NAME') }} EN</small></a>
        <small class="mx-2">|</small>
        <a href="/it/" class="text-medium-emphasis text-decoration-none footer-link"><small>{{ viteConfig('APP_NAME') }} IT</small></a> -->

        <RouterLink :to="{ name: 'home' }" class="text-medium-emphasis text-decoration-none footer-link">
          <small>{{ $t('navigation.createYourOwnCompetition') }}</small>
        </RouterLink>
      </div>

      <div class="text-medium-emphasis">
        <small>τ0 games</small>
      </div>
      
      <!-- Links section -->
      <div class="d-flex ga-4 text-center">
        <!-- <a 
          href="https://discord.gg/tT2pxsYaVF" 
          target="_blank" 
          rel="noopener" 
          class="text-decoration-none text-medium-emphasis footer-link">
          <small>Discord</small>
        </a>
        <span class="mx-2 text-medium-emphasis">|</span> -->
        <router-link 
          :to="{ name: 'privacy' }" 
          class="text-decoration-none text-medium-emphasis footer-link"
        >
          <small>{{ $t('privacy.privacyAndCookies') }}</small>
        </router-link>
      </div>
    </div>
  </v-footer>
</template>

<style scoped>
.app-footer {
  border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

.footer-link {
  transition: color 0.2s ease-in-out;
}

.footer-link:hover {
  color: rgb(var(--v-theme-primary)) !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .app-footer .pa-4 {
    padding: 16px 12px !important;
  }
}
</style>